import React from "react";
import { BRAND } from "../lib/api";

// Riquadro "Sistema digitale offerto da DF Consulting Group" mostrato sotto le
// schede raggiunte via QR: telefono, WhatsApp e sito sono cliccabili così chi
// scansiona può contattare direttamente il consulente.
export default function ProviderPromo() {
  const phoneDigits = BRAND.phone.replace(/[^\d+]/g, "");
  const waDigits = BRAND.whatsapp.replace(/\D/g, "");
  const linkClass = "font-semibold text-navy underline underline-offset-2";
  return <div className="rounded-lg bg-gold/10 px-4 py-3 text-center text-xs leading-relaxed text-navy/70">
    <p className="font-semibold text-navy">Sistema digitale offerto da DF Consulting Group</p>
    <p className="mt-0.5">{BRAND.parent}{BRAND.parentTitle ? ` – ${BRAND.parentTitle}` : ""}</p>
    <p className="mt-0.5">
      Tel. <a href={`tel:${phoneDigits}`} className={linkClass}>{BRAND.phoneDisplay}</a>
      {" · "}
      <a href={`https://wa.me/${waDigits}`} target="_blank" rel="noreferrer" className={linkClass}>WhatsApp</a>
    </p>
    <p className="mt-0.5">
      <a href={BRAND.website} target="_blank" rel="noreferrer" className={linkClass}>{BRAND.websiteDisplay}</a>
    </p>
  </div>;
}
